import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DEFAULT_LANG } from 'src/config/lang.config';
import { AuthService } from './auth.abstract.service';

@Injectable({
    providedIn: 'root',
})
export class AuthImplService implements AuthService {
    public baseUrl: string = environment.API_GATEWAY_URL;

    constructor(private http: HttpClient) {}

    public loginToExternalProvider(providerName: string): Observable<string> {
        let lang: string = DEFAULT_LANG;
        try {
            const stored = localStorage.getItem('bciti-language');
            if (stored) {
                lang = JSON.parse(stored);
            }
        } catch {
            lang = localStorage.getItem('bciti-language') || DEFAULT_LANG;
        }

        return this.http.post<string>(`${this.baseUrl}/connector-gateway/${providerName}/authenticate/admin?lang=${lang}`, {});
    }
}

export const AUTH_SERVICE_PROVIDER = {
    provide: AuthService,
    useClass: AuthImplService,
};
